import AppliesAPI from 'js/api/applies'

export default {

    /** 応募状況詳細画面 **/

    loadApplyStatusDetail ({commit}, data) {
        commit('setApplyStatusDetailLoadStatus', 1)

        AppliesAPI.loadApplyStatusDetail(data.id)
            .then(resp => {
                commit('setApplyStatusDetail', resp.data)
                commit('setApplyStatusDetailLoadStatus', 2)
            })
            .catch(err => {
                commit('setApplyStatusDetail', {})
                commit('setApplyStatusDetailLoadStatus', 3)
            })
    },

    resetApplyStatusDetail ({commit}) {
        commit('resetApplyStatusDetail')
    },

    // 応募状況保存
    saveApplyStatus ({commit}, data) {
        commit('setSaveApplyStatusDetailStatus', 1)

        AppliesAPI.saveApplyStatus(data)
            .then(resp => {
                commit('updateApplyStatusDetail', resp)
                commit('setSaveApplyStatusDetailStatus', 2)
            })
            .catch(err => {
                commit('setSaveApplyStatusDetailStatus', 3)
            })
    },

    // 提案用履歴情報保存
    saveApplyTech ({commit}, data) {
        commit('setSaveApplyTechStatus', 1)

        AppliesAPI.saveApplyTech(data)
            .then(resp => {
                commit('updateApplyTech', resp)
                commit('setSaveApplyTechStatus', 2)
            })
            .catch(err => {
                commit('setSaveApplyTechStatus', 3)
            })
    },

    /** 契約画面 **/

    loadContractInfo ({commit}, data) {
        commit('setContractInfoLoadStatus', 1)

        AppliesAPI.loadContractInfo(data)
            .then(resp => {
                commit('setContractInfo', resp)
                commit('setContractInfoLoadStatus', 2)
            })
            .catch(err => {
                commit('setContractInfo', {})
                commit('setContractInfoLoadStatus', 3)
            })
    },

    saveContractInfo ({commit}, data) {
        commit('resetContractOperat')
        commit('setSaveContractInfoStatus', 1)

        AppliesAPI.saveContractInfo(data)
            .then(resp => {
                commit('setAllErrors', {})
                commit('setContractOperat', 'success')
                commit('setContractInfo', resp)
                commit('setSaveContractInfoStatus', 2)
            })
            .catch(err => {
                commit('setContractOperat', data.operat)
                commit('setAllErrors', err.response.data.errors)
                commit('setSaveContractInfoStatus', 3)
            })
    },


    /** 応募詳細画面 **/

    loadAppDetail ({commit}, data) {
        commit('setAppDetailLoadStatus', 1)

        AppliesAPI.loadAppDetail(data.id)
            .then(resp => {
                commit('redirectCheck', resp.data)
                commit('setAppDetail', resp)
                commit('setAppDetailLoadStatus', 2)
            })
            .catch(err => {
                commit('setAppDetail', {})
                commit('setAppDetailLoadStatus', 3)
            })
    },

    resetAppDetail ({commit}) {
        commit('resetAppDetail')
    },

    // 公開単価設定
    applyPricePub ({commit, dispatch}, data) {
        commit('setAppPricePubStatus', 1)

        AppliesAPI.applyPricePub(data)
            .then(resp => {
                commit('setAppPricePubStatus', 2)

                dispatch('loadAppDetail', {id: resp.data.post_id})
            })
            .catch(err => {
                commit('setAppPricePubStatus', 3)
            })
    },

    // 氏名公開設定
    techNamePub ({commit, dispatch}, data) {
        commit('setAppNamePubStatus', 1)

        AppliesAPI.techNamePub(data)
            .then(resp => {
                commit('setAppNamePubStatus', 2)

                dispatch('loadAppDetail', {id: resp.data.post_id})
            })
            .catch(err => {
                commit('setAppNamePubStatus', 3)
            })
    },

    // 応募情報承認
    approvalApply ({commit, dispatch}, data) {
        commit('setApprovalApplyStatus', 1)

        AppliesAPI.approvalApply(data)
            .then(resp => {
                commit('setNewApplyPost', resp)
                commit('setApprovalApplyStatus', 2)

                dispatch('loadAppDetail', {id: resp.data.proj_id})
            })
            .catch(err => {
                commit('setApprovalApplyStatus', 3)
            })
    },

    // 入場確定
    enterConfirm ({commit, dispatch}, data) {
        commit('setEnterConfirmStatus', 1)

        AppliesAPI.enterConfirm(data)
            .then(resp => {
                commit('setEnterConfirmStatus', 2)
                dispatch('loadEnterDetail', {day: data.inD})
            })
            .catch(err => {
                commit('setEnterConfirmStatus', 3)
            })
    },

    // 面接・入場取消
    cancelIntv ({commit, dispatch}, data) {
        commit('setCancelIntvStatus', 1)

        AppliesAPI.cancelIntv(data)
            .then(resp => {
                commit('setCancelIntvStatus', 2)
                if (data.opt == '0') {
                    // 面接取り消しの場合
                    commit('setNewApplyPost', resp)
                    dispatch('loadAppDetail', {id: data.postId})
                } else {
                    // 入場取り消しの場合
                    dispatch('loadEnterDetail', {day: data.inD})
                }
            })
            .catch(err => {
                commit('setCancelIntvStatus', 3)
            })
    },

    /** 契約期間 **/
    contractPeriodSave ({commit, dispatch}, data) {
        commit('setContractPeriodSaveStatus', 1)

        AppliesAPI.contractPeriodSave(data)
            .then(resp => {
                commit('setContractPeriodSaveStatus', 2)
                if (data.opt == '0') {
                    // 入場予定詳細
                    dispatch('loadEnterDetail', {day: data.inD})
                } else {
                    commit('updateWorkToSelectList', resp.data)
                    commit('updateWorkToList', resp.data)
                }
            })
            .catch(err => {
                commit('setContractPeriodSaveStatus', 3)
            })
    },

    addInterview ({commit, dispatch, state}, data) {
        commit('setAddInterviewStatus', 1)

        AppliesAPI.addInterview(data)
            .then(resp => {
                commit('setAddedInterview', data)
                commit('setNewApplyPost', resp)
                commit('setAllErrors', {})
                commit('setAddInterviewStatus', 2)

                dispatch('loadAppDetail', {id: state.appDetail.data.post.proj_id})
            })
            .catch(err => {
                commit('setAllErrors', err.response.data.errors)
                commit('setAddInterviewStatus', 3)
            })
    },

    addNote ({commit, dispatch, state}, data) {
        commit('setAddNoteStatus', 1)
        
        AppliesAPI.addNote(data)
            .then(resp => {
                commit('setAllErrors', {})
                commit('setAddNoteStatus', 2)

                dispatch('loadAppDetail', {id: state.appDetail.data.post.proj_id})
            })
            .catch(err => {
                commit('setAllErrors', err.response.data.errors)
                commit('setAddNoteStatus', 3)
            })
    },

    sendMailDocNG ({commit, dispatch, state}, data) {
        commit('setSendMailDocNGStatus', 1)

        AppliesAPI.sendMailDocNG(data)
            .then(resp => {
                commit('setNewApplyPost', resp)
                commit('setSendMailDocNGStatus', 2)
                
                dispatch('loadAppDetail', {id: state.appDetail.data.post.proj_id})
            })
            .catch(err => {
                commit('setSendMailDocNGStatus', 3)
            })
    },

    sendMailIntvNG ({commit, dispatch, state}, data) {
        commit('setSendMailIntvNGStatus', 1)

        AppliesAPI.sendMailIntvNG(data)
            .then(resp => {
                commit('setNewApplyPost', resp)
                commit('setSendMailIntvNGStatus', 2)

                dispatch('loadAppDetail', {id: state.appDetail.data.post.proj_id})
            })
            .catch(err => {
                commit('setSendMailIntvNGStatus', 3)
            })
    },

    sendMailIntvOK ({commit, dispatch, state}, data) {
        commit('setSendMailIntvOKStatus', 1)

        AppliesAPI.sendMailIntvOK(data)
            .then(resp => {
                commit('setAddedEntrance', data)
                commit('setAddedEntranceToIntv', data)
                commit('setNewApplyPost', resp)
                commit('setAllErrors', {})
                commit('setSendMailIntvOKStatus', 2)

                dispatch('loadAppDetail', {id: state.appDetail.data.post.proj_id})
            })
            .catch(err => {
                commit('setAllErrors', err.response.data.errors)
                commit('setSendMailIntvOKStatus', 3)
            })
    },

    sendMailIntvOKWithNext ({commit, dispatch, state}, data) {
        commit('setSendMailIntvOKWithNextStatus', 1)

        AppliesAPI.sendMailIntvOKWithNext(data)
            .then(resp => {
                commit('setAddedInterview', data)
                commit('setNewApplyPost', resp)
                commit('setAllErrors', {})
                commit('setSendMailIntvOKWithNextStatus', 2)

                dispatch('loadAppDetail', {id: state.appDetail.data.post.proj_id})
            })
            .catch(err => {
                commit('setAllErrors', err.response.data.errors)
                commit('setSendMailIntvOKWithNextStatus', 3)
            })
    },

    loadEnterDetail ({commit}, data) {
        commit('setEnterDetailLoadStatus', 1)

        AppliesAPI.loadEnterDetail(data.day)
            .then(resp => {
                commit('setEnterDetail', resp)
                commit('setEnterDetailLoadStatus', 2)
            })
            .catch(err => {
                commit('setEnterDetail', {})
                commit('setEnterDetailLoadStatus', 3)
            })
    },
    
    resetEnterDetail ({commit}) {
        commit('resetEnterDetail')
    },

    /** 現場中など**/
    loadWorkStatus ({commit}, data) {
        commit('setWorkStatusLoadStatus', 1)

        AppliesAPI.loadWorkStatus(data)
            .then(resp => {
                commit('setWorkStatus', resp)
                commit('setWorkStatusLoadStatus', 2)
            })
            .catch(err => {
                commit('setWorkStatus', {})
                commit('setWorkStatusLoadStatus', 3)
            })
    },

    resetWorkStatus ({commit}) {
        commit('resetWorkStatus')
    },
    setWorkStatusSelected ({commit}, data) {
        commit('setWorkStatusSelected', data)
    },
    resetWorkStatusSelected ({commit} ) {
        commit('resetWorkStatusSelected')
    },

    /** 退場確定　**/
    exitConfirmSave ({commit}, data) {
        commit('setExitConfirmSaveStatus', 1)

        AppliesAPI.exitConfirmSave(data)
            .then(resp => {
                commit('updateWorkToSelectList', resp.data)
                commit('updateWorkToList', resp.data)

                commit('setExitConfirmSaveStatus', 2)
            })
            .catch(err => {
                commit('setExitConfirmSaveStatus', 3)
            })
    },

    // 退場済みに変更
    changeToExited ({commit, dispatch}, data) {
        commit('setChangeToExitedStatus', 1)

        AppliesAPI.changeToExited(data)
            .then(resp => {
                commit('updateWorkToSelectList', resp.data)
                commit('updateWorkToList', resp.data)

                commit('setChangeToExitedStatus', 2)
            })
            .catch(err => {
                commit('setChangeToExitedStatus', 3)
            })
    },

}
